module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_03_bg-cc03467d3924df417f78974452a272f8.png";